
const icons = {
  header: 'https://app.wonolo.com/assets/Horizontal_logo_23px.png'
};

export default icons;
